'use strict';

exports.__esModule = true;
exports.ChatRoomView = exports.styles = undefined;

var _class, _temp;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}; // import Call from "./Call";
// import CallsView from "./Calls/View";
// import Calls from "../../../../../Calls";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Object = require('@prisma-cms/society/lib/components/pages/ChatRooms/View/Object');

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Calls = require('./Calls');

var _Calls2 = _interopRequireDefault(_Calls);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = exports.styles = function styles(theme) {
  return _extends({}, (0, _Object.styles)(), {
    roomWrapper: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      flexBasis: "100%",
      width: "100%"
    }
  });
};

var ChatRoomView = exports.ChatRoomView = (_temp = _class = function (_ChatRoomViewProto) {
  _inherits(ChatRoomView, _ChatRoomViewProto);

  function ChatRoomView() {
    _classCallCheck(this, ChatRoomView);

    return _possibleConstructorReturn(this, _ChatRoomViewProto.apply(this, arguments));
  }

  ChatRoomView.prototype.renderDefaultView = function renderDefaultView() {
    var _context = this.context,
        Grid = _context.Grid,
        streams = _context.streams;
    var object = this.getObjectWithMutations();
    var _props = this.props,
        classes = _props.classes,
        use_calls = _props.use_calls;
    var content = null;

    if (!use_calls) {
      content = _ChatRoomViewProto.prototype.renderDefaultView.call(this);
    } else if (streams && streams.length) {
      content = _react2.default.createElement(Grid, {
        container: true,
        className: classes.container
      }, _react2.default.createElement(Grid, {
        item: true,
        xs: 8
      }, _react2.default.createElement(_Calls2.default, {
        ChatRoom: object
      })), _react2.default.createElement(Grid, {
        item: true,
        xs: 4
      }, _ChatRoomViewProto.prototype.renderDefaultView.call(this)));
    } else {
      content = _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_Calls2.default, {
        ChatRoom: object
      }), _ChatRoomViewProto.prototype.renderDefaultView.call(this));
    }

    return _react2.default.createElement('div', {
      className: classes.roomWrapper
    }, content);
  };

  return ChatRoomView;
}(_Object.ChatRoomView), _class.propTypes = _extends({}, _Object.ChatRoomView.propTypes, {
  use_calls: _propTypes2.default.bool.isRequired
}), _class.defaultProps = _extends({}, _Object.ChatRoomView.defaultProps, {
  use_calls: true
}), _temp);
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(ChatRoomView, props);
}); // export default withStyles(styles)(props => <ChatRoomView
//   {...props}
//   data={{
//     object: {},
//   }}
// />);